/**
 * @file number 相关 utils
 */
// @ts-expect-error no declaration file
import nzhcn from 'nzh/cn';
/**
 * 把数字转换为中文
 *
 * @category Number
 * @param n - 输入的数字
 * @returns 转换出的中文字符串
 * @example
 * ```javascript
 * numberToChinese(11.1) // 十一点一
 * ```
 */
export const numberToChinese = (n) => nzhcn.encodeS(n);
/**
 * 把数字转换为中文大写
 *
 * @category Number
 * @param n - 输入的数字
 * @returns 转换出的中文大写字符串
 * @example
 * ```javascript
 * numberToCapticalChinese(100111) // 壹拾万零壹佰壹拾壹
 * ```
 */
export const numberToCapticalChinese = (n) => nzhcn.encodeB(n);
/**
 * 检查一个变量是否是数字或数字字符串
 *
 * @category Number
 * @param n - 检查对象
 * @returns 检查结果
 * @example
 * ```javascript
 * isNumeric('1.1') // true
 * isNumeric('1s') // false
 * ```
 */
export const isNumeric = (n) => 
// eslint-disable-next-line
n !== '' && !isNaN(n);
/**
 * 判断数字是否为偶数.
 *
 * @category Number
 * @param n - 数字
 * @returns 是否为偶数
 */
export const isEven = (n) => n % 2 === 0;
/**
 * 判断数字是否为奇数.
 *
 * @category Number
 * @param n - 数字
 * @returns 是否为奇数
 */
export const isOdd = (n) => Math.abs(n % 2) === 1;
/**
 * 判断数字是否为正数
 *
 * @category Number
 * @param n - 数字
 * @returns 是否为正数
 */
export const isPositive = (n) => Number(n) >= 0;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibnVtYmVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL2Z1bmN0aW9ucy9udW1iZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7O0dBRUc7QUFFSCx1Q0FBdUM7QUFDdkMsT0FBTyxLQUFLLE1BQU0sUUFBUSxDQUFBO0FBRTFCOzs7Ozs7Ozs7O0dBVUc7QUFDSCxNQUFNLENBQUMsTUFBTSxlQUFlLEdBQUcsQ0FBQyxDQUFTLEVBQVUsRUFBRSxDQUFDLEtBQUssQ0FBQyxPQUFPLENBQUMsQ0FBQyxDQUFDLENBQUE7QUFFdEU7Ozs7Ozs7Ozs7R0FVRztBQUNILE1BQU0sQ0FBQyxNQUFNLHVCQUF1QixHQUFHLENBQUMsQ0FBUyxFQUFVLEVBQUUsQ0FBQyxLQUFLLENBQUMsT0FBTyxDQUFDLENBQUMsQ0FBQyxDQUFBO0FBRTlFOzs7Ozs7Ozs7OztHQVdHO0FBQ0gsTUFBTSxDQUFDLE1BQU0sU0FBUyxHQUFHLENBQUMsQ0FBa0IsRUFBRSxFQUFFO0FBQzlDLDJCQUEyQjtBQUMzQixDQUFDLEtBQUssRUFBRSxJQUFJLENBQUMsS0FBSyxDQUFDLENBQVEsQ0FBQyxDQUFBO0FBRTlCOzs7Ozs7R0FNRztBQUNILE1BQU0sQ0FBQyxNQUFNLE1BQU0sR0FBRyxDQUFDLENBQVMsRUFBRSxFQUFFLENBQUMsQ0FBQyxHQUFHLENBQUMsS0FBSyxDQUFDLENBQUE7QUFFaEQ7Ozs7OztHQU1HO0FBQ0gsTUFBTSxDQUFDLE1BQU0sS0FBSyxHQUFHLENBQUMsQ0FBUyxFQUFFLEVBQUUsQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFDLENBQUMsR0FBRyxDQUFDLENBQUMsS0FBSyxDQUFDLENBQUE7QUFFekQ7Ozs7OztHQU1HO0FBQ0gsTUFBTSxDQUFDLE1BQU0sVUFBVSxHQUFHLENBQUMsQ0FBMEIsRUFBRSxFQUFFLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsQ0FBQSJ9